import Upload from 'src/pages/Collections/Submission/Steps/Upload/Upload'

const OvtUpload = () => <Upload isOvt />
export default OvtUpload
